<template>
  <div>
    <components :is="currentView"></components>
  </div>
</template>
<script>
import detail from './detail/index.vue';
import share from './share/index.vue';
export default {
  name: 'headlineDetail',
  data() {
    return {
      currentView: ''
    };
  },
  methods: {},
  computed: {},
  components: {
    detail,
    share
  },
  watch: {},
  created() {
    let wxUserInfo = this.$api.getStorage('wxUserInfo') || {};

    if (/shareFlag/.test(location.href) && !wxUserInfo.phone) {
      this.currentView = 'share';
    } else {
      this.currentView = 'detail';
    }
  }
};
</script>
<style scoped lang="less"></style>
